module.exports = __webpack_public_path__ + "img/chat_4.95fdcd50.png";